import { useMutation, useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { usePostHog } from "posthog-js/react";
import { useSWRConfig } from "swr";
import api from "~/shared/api/core/api";
import { PARTICIPANTS_KEYS } from "~/shared/api/participants/participants.queries";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { SAVED_ROLES_EVENTS } from "~/shared/constants/events.constants";

export function useRemoveSavedRoleById({ savedRoleId }: { savedRoleId: number }) {
  const postHog = usePostHog();
  const { data: user } = useSuspenseQuery(USERS_QUERIES.profile());
  const queryClient = useQueryClient();
  const { mutate } = useSWRConfig();

  return useMutation({
    mutationFn: async () => {
      postHog.capture(SAVED_ROLES_EVENTS.SAVE_ROLE_DELETE_INITIATED);

      const res = await api.delete(`/participants/${user.id}/saved/roles/${savedRoleId}`);

      return res.data;
    },
    onSuccess: () => {
      mutate(checkJobKey);

      return queryClient.invalidateQueries({
        queryKey: PARTICIPANTS_KEYS.savedRoles(user.id.toString()),
      });
    },
  });
}

const checkJobKey = (args: string | [string, unknown]) => {
  if (typeof args === "string") return false;

  const [key] = args;

  if (key.startsWith("jobs")) {
    return true;
  }
};
